
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { mapState } from "vuex";
import contractApi from "@/api/blContract";
import pdf from 'vue-pdf';
import emit_on from "@/common/emit_on";

export default {
components: {
Popup,
XButton,
pdf
},
data() {
return {
contentHeight:
(document.documentElement.clientHeight - 48 - 15).toString() + "px",
isSigning: false,
itemContractSigned :'',
canSign: false,
numPages: undefined,
goReload: false,
currentPage: 0,
pageCount: 0,
url: "",
src: "",
signBtn: {
state: false,
text: '签章',
isShow: true
},
};
},
computed: {
...mapState(["contractPopup"])
},
mounted() {

},
watch: {
contractPopup(val) {
this.currentPage = 1;
this.url = encodeURIComponent(this.contractPopup.imgSrc);
this.getIfCanSign();
/* var loadingTask = pdf.createLoadingTask(this.url);
console.log(loadingTask)
this.readContractPdf = loadingTask;
this.readContractPdf.then(pdf => {
this.numPages = pdf.numPages;
}); */

},
pageCount(val) {
if (!this.pageCount) {
this.pageCount = 1;
}
}
},
methods: {
changePdfPage(val) { //翻页
if (val === 0 && this.currentPage > 1) {
this.currentPage--
}
if (val === 1 && this.currentPage < this.pageCount) {
this.currentPage++

}
},

loadPdfHandler(e) {
this.currentPage = 1 
},
closeContract() {
this.contractPopup.isShowContract = false;
if (this.goReload) {
this.$router.go(0);
}
},
/**
* 合同签章
*/
async signContract() {

this.isSigning = 1;
let subUrl = this.contractPopup.imgSrc.split("?")[1];
let paramObj = this.$Utils.getParams(subUrl);
const _this = this;
this.signBtn.state = true;
this.signBtn.text = '签章中…';

try {
if (this.contractPopup.isSignMainContract) {//签署主合同
let res = await contractApi.signContractForMain({
contractId: paramObj["contractId"]
});
if (Number(res.code) === 0) {
this.$store.commit("SHOWTOAST", "合同签章成功");
this.contractPopup.isShowSign = false;
this.goReload = true;
} else {
this.$store.commit("SHOWTOAST", "合同签章失败");
this.contractPopup.isShowSign = true;
}
} else {//签署项目合同
let res = await contractApi.sign({
contractId: paramObj["contractId"]
});

if (res.code === 0) {
if (res.result !== '签章成功') {
window.location.href = res.result;
} else {
this.signBtn.text = '已签章';
this.signBtn.state = true;
}
} else {

this.$store.commit("SHOWTOAST", res.msg + '' + res.result);
this.signBtn.text = '签章';
this.signBtn.state = false;
}
}
} catch (err) {
console.error(err);
this.$store.commit("SHOWTOAST", "服务器异常");
}
this.isSigning = false;
},

async getIfCanSign(){
let subUrl = this.contractPopup.imgSrc.split("?")[1];
let paramObj = this.$Utils.getParams(subUrl);
let state = this.contractPopup.itemContractSigned;
const CUSTOMER_UN_SIGN = "6"; 
let res = await contractApi.getIfCanSign({// 校验是否可签章
contractId: paramObj["contractId"]
})
console.log(res)
if (res.code == 0) {
const customerType = res.result;
if(state == CUSTOMER_UN_SIGN){
if(customerType=='1'){//个人
this.signBtn.text = '签章';
}else{
this.signBtn.text = '法定代表人签章';
}
this.signBtn.state = false;
}else if(state=='22'){
this.signBtn.text = '签署公章';
this.signBtn.state = false;
}else{
this.signBtn.text = '已签章';
this.signBtn.state = true;
}
} else {
if(state == CUSTOMER_UN_SIGN){
this.signBtn.text = '无权签署！';
this.signBtn.state = true;
}else{
this.signBtn.text = '已签章';
this.signBtn.state = true;
}
}
console.log(res)
}
},

}



// WEBPACK FOOTER //
// ./src/components/contractPopup.vue